(function () {
  var root = document.querySelector('.cxcat');
  if (!root || root.dataset.ready === '1') return;
  root.dataset.ready = '1';

  var search = root.querySelector('#cxcat-search');
  var query = root.querySelector('#cxcat-query');
  var typing = root.querySelector('.cxcat-typing');
  var searchButton = root.querySelector('.cxcat-search-go');
  var searchFit = root.querySelector('#cxcat-search-fit');
  var examples = Array.prototype.slice.call(root.querySelectorAll('[data-cxcat-query]'));
  var results = root.querySelector('#cxcat-results');
  var resultsTitle = root.querySelector('#cxcat-results-title');
  var resultsWhy = root.querySelector('#cxcat-results-why');
  var resultsGrid = root.querySelector('#cxcat-results-grid');
  var resultsClear = root.querySelector('#cxcat-results-clear');
  var measureFit = root.querySelector('#cxcat-measure-fit');
  var fitMemory = root.querySelector('#cxcat-fit-memory');
  var fitTitle = root.querySelector('#cxcat-fit-title');
  var fitDetail = root.querySelector('#cxcat-fit-detail');
  var fitOnly = root.querySelector('#cxcat-fit-only');
  var fitOriginal = root.querySelector('#cxcat-fit-original');
  var cards = {};
  var catalog = [];
  var fitByHandle = {};
  var vtoHandles = {};
  /* 2026-09-24: Try on only for frames with a try-on overlay (same list as TRYON in page.seen-it.liquid, from FRAMES in page.try-on.liquid). Add new overlay handles here too. */
  ["barra-matte-black-chromapop-polarized-bronze-mirror-lens","blenders-a-series","blenders-falcon","blenders-grove","blenders-h-series","blenders-mesa","blenders-millenia-x2","blenders-north-park","blenders-palmy","blenders-romeo","blenders-scifi","blenders-shadow","blenders-skyway","blenders-sydney","guides-choice-xl-matte-black-chromapop-glass-polarized-blue-mirror-lens","heat-wave-apollo-sunglasses","heat-wave-carat","heat-wave-clarity","heat-wave-future-tech-z87","heat-wave-incline-sunglasses-polished-gold-frame-amber-lens","heat-wave-marylin","heat-wave-performance-lazerface-z87","heat-wave-performance-quatro-z87","heat-wave-performance-rayth-z87","heat-wave-performance-vise-z87","heat-wave-performance-xl-vise-z87","heat-wave-rayth-z87","heat-wave-skynet-sunglasses-black-z87","heat-wave-vise-z87","heat-wave-xl-vise-z87","lowdown-xl-2-matte-black-chromapop-polarized-black-lens","oakley-actuator","oakley-actuator-sq","oakley-bisphaera","oakley-bisphaera-speed","oakley-bxtr","oakley-bxtr-metal","oakley-chaminade","oakley-corridor","oakley-corridor-sq","oakley-det-cord-industrial-z87","oakley-encoder","oakley-encoder-strike-vented","oakley-flak-2-0-s","oakley-flak-2-0-xl","oakley-flak-2-0-xxl","oakley-frogskins","oakley-frogskins-hybrid","oakley-frogskins-lite","oakley-frogskins-range","oakley-frogskins-range-xl","oakley-frogskins-s","oakley-fuel-cell","oakley-gascan","oakley-half-jacket-2-0-xl","oakley-heliostat","oakley-highland","oakley-holbrook","oakley-holbrook-metal","oakley-holbrook-mix","oakley-holbrook-s","oakley-holbrook-ti","oakley-holbrook-xl","oakley-holbrook-xxl","oakley-hstn-sq","oakley-hydra","oakley-instagator","oakley-kato","oakley-latch","oakley-latch-beta","oakley-latch-panel","oakley-lateralis","oakley-mainlink","oakley-permian","oakley-plazma","oakley-radar-ev-path","oakley-radar-ev-pitch","oakley-radar-ev-s-path","oakley-radar-plate","oakley-sielo","oakley-sielo-sq","oakley-sphaera","oakley-sphaera-slash","oakley-sphaera-strike","oakley-split-shot","oakley-stunt-devil","oakley-stunt-devil-s","oakley-sutro","oakley-sutro-lite","oakley-sutro-lite-s","oakley-sutro-lite-sweep","oakley-sutro-s","oakley-sutro-ti","oakley-sutro-ti-sweep","oakley-turbine","oakley-turbine-rotor","riptide-matte-tortoise-chromapop-glass-polarized-green-mirror-lens","smith-arvo","smith-backcast","smith-bobcat","smith-cheetah","smith-cypher","smith-defy","smith-embark","smith-emerge","smith-guides-choice-bifocal","smith-guides-choice-s","smith-hookset","smith-lake-shasta","smith-langley-2","smith-lineup","smith-lowdown-2-core","smith-lowdown-slim-2","smith-mono-lake","smith-monroe-peak","smith-motive","smith-outrigger","smith-pursuit","smith-redding-2","smith-seeker","smith-shift-split-mag","smith-shift-xl-mag","smith-shoutout-core","smith-sliders","smith-strand","smith-sway","smith-syncline","smith-truss","smith-ultralite","smith-venture","smith-vert","smith-westward","smith-westward-core","smith-wildcat","smith-xc","stoggles-cat-eye","stoggles-square","suncloud-aviator","suncloud-aviator-reader","suncloud-biff","suncloud-boone","suncloud-bridge-city","suncloud-cityscape","suncloud-cookie","suncloud-cookie-reader-sale","suncloud-double-up","suncloud-duet","suncloud-hundo","suncloud-lowkey","suncloud-mayor","suncloud-mayor-reader-sale","suncloud-metric","suncloud-milestone","suncloud-milestone-reader-sale","suncloud-patrol","suncloud-quiver","suncloud-rambler","suncloud-rambler-lite","suncloud-respek","suncloud-sandy","suncloud-sashay","suncloud-sentry","suncloud-voucher","suncloud-zephyr","suncloud-zephyr-reader-sale","wiley-x-apex-z87","wiley-x-axe-z87","wiley-x-boss-z87","wiley-x-enzo-z87","wiley-x-gravity-z87","wiley-x-guard-advanced","wiley-x-ovation-z87","wiley-x-p17-z87"].forEach(function (h) { vtoHandles[h] = true; });
  var nativeObserver = null;
  var nativeTimer = null;
  var fitOnlyActive = false;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function event(name, params) {
    try { if (typeof gtag === 'function') gtag('event', name, params || {}); } catch (error) {}
  }

  function faceWidth() {
    try {
      var value = parseFloat(localStorage.getItem('cxvto_face_mm'));
      return value > 100 && value < 200 ? value : 0;
    } catch (error) { return 0; }
  }

  var faceMM = faceWidth();

  function verdict(frameMM) {
    if (!faceMM || !frameMM) return null;
    var delta = frameMM - faceMM;
    if (delta < -5) return { kind: 'narrow', label: 'Runs narrow', delta: delta, score: 999 };
    if (delta > 9) return { kind: 'wide', label: 'Runs wide', delta: delta, score: 999 };
    return { kind: 'fit', label: 'Fits you', delta: delta, score: Math.abs(delta - 2) };
  }

  function productHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      var path = new URL(link.href, location.origin).pathname.split('/products/')[1] || '';
      return path.split('/')[0].split('?')[0];
    } catch (error) { return ''; }
  }

  function nativeFitRow(card, frameMM) {
    var existing = card.querySelector('.cxcat-native-fit');
    if (existing) existing.remove();
    var fit = verdict(frameMM);
    if (!fit) return;
    var info = card.querySelector('.card-information');
    if (!info) return;
    var row = document.createElement('div');
    row.className = 'cxcat-native-fit' + (fit.kind === 'fit' ? '' : ' is-warn');
    var label = document.createElement('strong');
    label.textContent = fit.label;
    var detail = document.createElement('span');
    detail.textContent = Math.round(frameMM) + 'mm / your ' + Math.round(faceMM) + 'mm fit';
    row.appendChild(label);
    row.appendChild(detail);
    var price = info.querySelector('.price');
    info.insertBefore(row, price || null);
  }

  function nativeCardActions(card, handle) {
    var stage = card.querySelector('.card__inner');
    if (!stage || !handle || stage.querySelector('.cxcat-native-actions')) return;
    var actions = document.createElement('div');
    actions.className = 'cxcat-native-actions' + (vtoHandles[handle] ? '' : ' is-single');
    var view = document.createElement('a');
    view.href = '/products/' + handle;
    view.textContent = 'View pair';
    actions.appendChild(view);
    if (vtoHandles[handle]) {
      var tryOn = document.createElement('a');
      tryOn.href = '/pages/virtual-try-on?product=' + encodeURIComponent(handle);
      tryOn.textContent = 'Try on';
      actions.appendChild(tryOn);
    }
    stage.appendChild(actions);
  }

  function decorateNativeGrid() {
    var items = Array.prototype.slice.call(document.querySelectorAll('#product-grid > .grid__item'));
    var pageFits = 0;
    items.forEach(function (item, index) {
      item.style.setProperty('--cxcat-product-delay', Math.min(index, 7) * 35 + 'ms');
      var card = item.querySelector('.card-wrapper');
      var handle = card ? productHandle(card) : '';
      var flag = item.querySelector('.cx-fit-flag');
      var frameMM = flag ? parseInt(flag.getAttribute('data-mm'), 10) : 0;
      if (card) nativeCardActions(card, handle);
      if (!faceMM) return;
      if (card && frameMM) nativeFitRow(card, frameMM);
      var fit = verdict(frameMM);
      if (fit && fit.kind === 'fit') pageFits += 1;
      item.classList.toggle('cxcat-fit-hidden', fitOnlyActive && (!fit || fit.kind !== 'fit'));
    });
    if (!faceMM) return;
    var allFits = Object.keys(fitByHandle).filter(function (handle) {
      var item = fitByHandle[handle];
      var fit = verdict(Number(item.mm));
      return fit && fit.kind === 'fit';
    }).length;
    if (allFits) fitDetail.textContent = allFits + ' measured frames across the store fit your profile. ' + pageFits + ' are on this page.';
  }

  function showFitMemory() {
    if (!faceMM) return;
    fitMemory.hidden = false;
    searchFit.classList.add('is-visible');
    fitTitle.textContent = 'Your ' + Math.round(faceMM) + 'mm fit is remembered.';
    fitDetail.textContent = 'Measured by Virtual Try-On and stored only on this device.';
  }

  function watchNativeGrid() {
    var target = document.querySelector('#ProductGridContainer');
    if (!target || !window.MutationObserver || nativeObserver) return;
    nativeObserver = new MutationObserver(function () {
      window.clearTimeout(nativeTimer);
      nativeTimer = window.setTimeout(decorateNativeGrid, 180);
    });
    nativeObserver.observe(target, { childList: true, subtree: true });
  }

  function money(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return '$' + (number % 1 ? number.toFixed(2) : number.toFixed(0));
  }

  function resultCard(model) {
    var card = cards[model];
    if (!card || !card.handle) return null;
    var article = document.createElement('article');
    article.className = 'cxcat-result';

    var mediaLink = document.createElement('a');
    mediaLink.className = 'cxcat-result-media';
    mediaLink.href = '/products/' + card.handle;
    var image = document.createElement('img');
    image.src = card.img || '';
    image.alt = card.title || model;
    image.loading = 'lazy';
    mediaLink.appendChild(image);

    var body = document.createElement('div');
    body.className = 'cxcat-result-body';
    var vendor = document.createElement('p');
    vendor.className = 'cxcat-result-vendor';
    vendor.textContent = card.vendor || '';
    var title = document.createElement('h3');
    title.textContent = card.title || model;
    var fitRow = document.createElement('div');
    fitRow.className = 'cxcat-result-fit';
    var fitData = fitByHandle[card.handle];
    var fit = verdict(fitData && Number(fitData.mm));
    if (fit) {
      if (fit.kind !== 'fit') fitRow.classList.add('is-warn');
      var fitLabel = document.createElement('strong');
      fitLabel.textContent = fit.label;
      var fitText = document.createElement('span');
      fitText.textContent = Math.round(Number(fitData.mm)) + 'mm / your ' + Math.round(faceMM) + 'mm fit';
      fitRow.appendChild(fitLabel);
      fitRow.appendChild(fitText);
    } else {
      if (faceMM) fitRow.textContent = 'Fit measurement unavailable';
      else fitRow.classList.add('is-empty');
    }
    var price = document.createElement('p');
    price.className = 'cxcat-result-price';
    price.textContent = money(card.price);
    var actions = document.createElement('div');
    actions.className = 'cxcat-result-actions';
    var shop = document.createElement('a');
    shop.href = '/products/' + card.handle;
    shop.textContent = 'View pair';
    actions.appendChild(shop);
    if (vtoHandles[card.handle]) {
      var tryOn = document.createElement('a');
      tryOn.href = '/pages/virtual-try-on?product=' + encodeURIComponent(card.handle);
      tryOn.textContent = 'Try on';
      actions.appendChild(tryOn);
    } else {
      actions.className += ' is-single';
    }
    body.appendChild(vendor);
    body.appendChild(title);
    body.appendChild(fitRow);
    body.appendChild(price);
    body.appendChild(actions);
    article.appendChild(mediaLink);
    article.appendChild(body);
    return article;
  }

  function rankedModels(models) {
    if (!faceMM) return models;
    return models.map(function (model, index) {
      var card = cards[model];
      var fitData = card && fitByHandle[card.handle];
      var fit = verdict(fitData && Number(fitData.mm));
      return { model: model, index: index, fit: fit };
    }).sort(function (a, b) {
      var aGroup = a.fit && a.fit.kind === 'fit' ? 0 : 1;
      var bGroup = b.fit && b.fit.kind === 'fit' ? 0 : 1;
      return aGroup - bGroup || a.index - b.index;
    }).map(function (entry) { return entry.model; });
  }

  function renderResults(models, whyText) {
    resultsGrid.innerHTML = '';
    var valid = rankedModels(models).map(resultCard).filter(Boolean);
    if (!valid.length) {
      var empty = document.createElement('div');
      empty.className = 'cxcat-loading';
      empty.textContent = 'No exact match. Try a shape, lens, job, movie, or person.';
      resultsGrid.appendChild(empty);
    } else {
      valid.forEach(function (card, index) {
        card.style.setProperty('--cxcat-result-delay', Math.min(index, 7) * 55 + 'ms');
        resultsGrid.appendChild(card);
      });
    }
    resultsWhy.textContent = whyText || (faceMM ? 'Matched by description, then checked against your saved fit.' : 'Matched against the live eyewear catalog.');
  }

  var dataReady = Promise.all([
    fetch(root.getAttribute('data-cards-url')).then(function (response) { return response.json(); }),
    fetch(root.getAttribute('data-fit-url')).then(function (response) { return response.json(); })
  ]).then(function (payload) {
    cards = payload[0] || {};
    catalog = Object.keys(cards).map(function (model) { return { model: model }; });
    (payload[1] || []).forEach(function (item) { if (item && item.handle) fitByHandle[item.handle] = item; });
    showFitMemory();
    decorateNativeGrid();
    watchNativeGrid();
  }).catch(function () {
    showFitMemory();
    decorateNativeGrid();
    watchNativeGrid();
  });

  function runSearch() {
    var text = (query.value || '').trim();
    if (!text) return;
    search.classList.add('has-value');
    results.hidden = false;
    resultsTitle.textContent = '"' + text + '"';
    resultsWhy.textContent = 'Reading the whole wall for that...';
    resultsGrid.innerHTML = '<div class="cxcat-loading">Matching description, catalog, and fit...</div>';
    searchButton.disabled = true;
    event('cxsearch_catalog_ask', { q: text.slice(0, 60), fit: faceMM ? 1 : 0 });

    dataReady.then(function () {
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (controller) controller.abort(); }, 6000);
      return fetch(root.getAttribute('data-endpoint'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({ q: text, catalog: catalog })
      }).then(function (response) { return response.json(); }).then(function (response) {
        window.clearTimeout(timer);
        var models = (response && response.models || []).filter(function (model) { return cards[model]; });
        renderResults(models, response && response.why);
        event('cxsearch_catalog_result', { q: text.slice(0, 60), n: models.length, fit: faceMM ? 1 : 0 });
      });
    }).catch(function () {
      renderResults([], 'The matcher did not answer. The full catalog is still available below.');
    }).finally(function () {
      searchButton.disabled = false;
      results.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  search.addEventListener('submit', function (eventObject) {
    eventObject.preventDefault();
    runSearch();
  });
  query.addEventListener('input', function () { search.classList.toggle('has-value', query.value.length > 0); });
  examples.forEach(function (button) {
    button.addEventListener('click', function () {
      query.value = button.getAttribute('data-cxcat-query') || '';
      search.classList.add('has-value');
      query.focus();
    });
  });
  resultsClear.addEventListener('click', function () {
    results.hidden = true;
    query.value = '';
    search.classList.remove('has-value');
    query.focus();
  });
  if (measureFit) {
    measureFit.hidden = !!faceMM;
    measureFit.addEventListener('click', function () {
      event('cxsearch_measure_fit', { source: 'catalog_results' });
    });
  }
  fitOnly.addEventListener('click', function () {
    fitOnlyActive = fitOnly.getAttribute('aria-pressed') !== 'true';
    fitOnly.setAttribute('aria-pressed', String(fitOnlyActive));
    fitOnly.classList.toggle('is-active', fitOnlyActive);
    decorateNativeGrid();
    event('collection_fit_only', { active: fitOnlyActive ? 1 : 0 });
  });
  fitOriginal.addEventListener('click', function () {
    try { sessionStorage.setItem('cxfit_nosort', '1'); } catch (error) {}
    location.reload();
  });

  if (!reduced) {
    var prompts = [
      '90s action villain. Clear lens. Not too sporty.',
      'The sunglasses Ryan Gosling wears between takes.',
      'Wide black frame. Blue lens. Bay-floor proof.',
      'Top Gun, but prescription and actually comfortable.'
    ];
    var promptIndex = 0;
    var charIndex = 0;
    var erasing = false;
    function typePrompt() {
      if (document.activeElement === query || query.value) {
        window.setTimeout(typePrompt, 180);
        return;
      }
      var phrase = prompts[promptIndex];
      typing.textContent = phrase.slice(0, charIndex);
      if (!erasing && charIndex < phrase.length) {
        charIndex += 1;
        window.setTimeout(typePrompt, 34);
      } else if (!erasing) {
        erasing = true;
        window.setTimeout(typePrompt, 1500);
      } else if (charIndex > 0) {
        charIndex -= 1;
        window.setTimeout(typePrompt, 16);
      } else {
        erasing = false;
        promptIndex = (promptIndex + 1) % prompts.length;
        window.setTimeout(typePrompt, 260);
      }
    }
    typePrompt();
  } else {
    typing.textContent = '90s action villain. Clear lens. Not too sporty.';
  }

  showFitMemory();
  decorateNativeGrid();
  watchNativeGrid();
})();
